import * as React from "react";
const SvgFiRrBlueberries = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-blueberries_svg__a)">
      <path
        fill="#062147"
        d="M24 8.5C24 3.813 20.187 0 15.5 0c-4.188 0-7.726 3.069-8.388 7.124C3.084 7.79 0 11.287 0 15.5 0 20.187 3.813 24 8.5 24c4.216 0 7.715-3.088 8.378-7.119C20.954 16.214 24 12.659 24 8.5M8.5 22A6.51 6.51 0 0 1 2 15.5C2 11.916 4.916 9 8.5 9s6.5 2.916 6.5 6.5S12.084 22 8.5 22m8.465-7.194a8.504 8.504 0 0 0-7.791-7.772C9.843 4.142 12.442 2 15.501 2c3.584 0 6.5 2.916 6.5 6.5 0 3.037-2.132 5.631-5.036 6.306M19 6a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-2 0V7h-1a1 1 0 0 1 0-2h1V4a1 1 0 0 1 2 0v1h1a1 1 0 0 1 1 1m-7 7a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-2 0v-1H7a1 1 0 0 1 0-2h1v-1a1 1 0 0 1 2 0v1h1a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-blueberries_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBlueberries;
